import React from "react";
import useResponsive from "../../hooks/useResponsive";

const ResponsivePage = ({
  children,
  title,
  subtitle,
  actions,
  fullWidth = false,
}) => {
  const { isMobile, isTablet } = useResponsive();

  const horizontalPadding = isMobile ? 12 : isTablet ? 16 : 24;

  return (
    <div
      style={{
        width: "100%",
        maxWidth: fullWidth ? "100%" : 1600,
        margin: "0 auto",
        padding: horizontalPadding,
        boxSizing: "border-box",
      }}
    >
      {(title || actions) && (
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "flex-start" : "center",
            gap: 12,
            marginBottom: 20,
          }}
        >
          <div>
            {title && (
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? 22 : 28,
                  fontWeight: 700,
                }}
              >
                {title}
              </h2>
            )}

            {subtitle && (
              <p
                style={{
                  marginTop: 6,
                  color: "#6b7280",
                  marginBottom: 0,
                }}
              >
                {subtitle}
              </p>
            )}
          </div>

          {actions && (
            <div
              style={{
                width: isMobile ? "100%" : "auto",
              }}
            >
              {actions}
            </div>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default ResponsivePage;
